module.exports = __webpack_public_path__ + "static/media/lizScene-01.f04acfc1.jpg";